module.exports = __webpack_public_path__ + "img/Weapon_123.b3a7dfb1.png";